import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";
import moment from "moment";

export default {
  state() {
    return {
      rightDrawer: false,
      rightDrawerCollapsers: null,
      singularDatePicker: false,
      selectedFilters: {
        startDate: moment(),
        endDate: moment(),
        singleDate: moment(),
        product: {
          hierarchy: {},
          productList: [],
          internalCode: null,
          productDescription: null,
        },
        store: {
          hierarchy: {},
          storeList: [],
        },
        geography: {
          hierarchy: {},
          nielsenList: [],
        },
        employee: {
          employeeList: [],
        },
        sellers: {
          salesDirector: null,
          NAM: null,
          KAM: null,
          supervisor: null,
          seller: null,
          promoter: null,
          repositor: null,
        },
      },
      customFilters: {
        dwsa_aggreg: null,
        coverage_days: null,
        abcSelected: null,
        cardexStatus: null,
      },
      hierarchyLevelElements: [],
    };
  },
  mutations,
  actions,
  getters,
};
